import { STORE_NUDGE_STORAGE_PREFIX } from './constants'

import type { StoreNudgeSeenState } from './types'

type StorageKeyInput = {
  /** Id numérico do evento — nunca o slug, que se repete entre edições. */
  digitalProductId: number
  userId: number
}

export const storageKey = ({ digitalProductId, userId }: StorageKeyInput) =>
  `${STORE_NUDGE_STORAGE_PREFIX}:${digitalProductId}:${userId}`

const isSeenState = (value: unknown): value is StoreNudgeSeenState => {
  if (!value || typeof value !== 'object') return false
  const candidate = value as Record<string, unknown>
  return (
    typeof candidate.affordAnnounced === 'boolean' &&
    Array.isArray(candidate.announcedRewardIds) &&
    (candidate.lastShownAt === null || typeof candidate.lastShownAt === 'string')
  )
}

/**
 * Estado de "já anunciado", tolerante a armazenamento indisponível: modo
 * privado, cota estourada e JSON corrompido viram "ausente", nunca exceção.
 */
export const readSeenState = (key: string): StoreNudgeSeenState | null => {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(key)
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    return isSeenState(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const writeSeenState = (key: string, state: StoreNudgeSeenState): void => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(key, JSON.stringify(state))
  } catch {
    /* quota / modo privado: o hook mantém o estado em memória na sessão */
  }
}
